<div class="assets-section-container" [class.add-space]="!items || items.length" [class.dark]="darkGalleryBackground">
  @if (!blockEmbedAssetView) {
  <div class="assets-section" [style.maxWidth]="embedMode ? '' : sectionWidth + 'px'">
    <div
      #assetGallery
      class="assets"
      [style.height]="sectionHeight + 'px'"
      [class.block-img-right-click]="!gallery.download_single_asset && accessLevel !== 'edit'"
    >
      @for (item of visibleItems; track item.asset.id) {
      <a
        class="asset"
        [class.with-bg]="
          item.asset.type !== 'image' || !(item.asset.version_data.asset_name | assetSupportsTransparency)
        "
        [routerLink]="[item.asset.id]"
        [queryParams]="queryParams"
        id="asset-{{ item.asset.id }}"
        [style.width]="item.dimensions.width + 'px'"
        [style.height]="item.dimensions.height + 'px'"
        [style.left]="item.dimensions.x + 'px'"
        [style.top]="item.dimensions.y + 'px'"
        (mouseenter)="hoverItem = item"
        (mouseleave)="hoverItem = undefined"
      >
        @if ( item.asset.type === 'image' && item.asset | assetUrl: item.asset.version_data.watermark_uuid :
        item.dimensions.width : true | async; as assetSrc ) {
        <img [src]="assetSrc" [width]="item.dimensions.width" [height]="item.dimensions.height" alt="" loading="lazy" />
        } @if (item.asset.type === 'video') { @if (isDesktop && (item.asset | canDisplayAsset)) {
        <app-video-viewer
          [videoData]="$any(item.asset.version_data.data)"
          [assetVersion]="item.asset.version_data"
          [asset]="item.asset"
          [uuid]="item.asset.version_data.uuid"
          [origin]="item.asset.version_data.asset_name"
          [poster]="
            item.asset.version_data
              | assetVersionUrl
                : item.asset.version_data.uuid
                : item.asset.version_data['status']
                : item.asset.version_data.watermark_uuid
                : item.dimensions.width
                : true
                : item.asset.watermark_enabled
              | async
          "
          [active]="hoverItem === item"
          [showUi]="false"
          [handleUi]="false"
          [autoplay]="hoverItem === item"
          [muted]="true"
          [allowUnmute]="true"
          [loop]="true"
          [targetWidth]="item.dimensions.width"
          #video
        >
        </app-video-viewer>
        @if (video.status !== 'playing') {
        <div class="video-indicator" [class.loading]="video.status === 'loading'">
          <app-svg src="/assets/icons/play.svg"></app-svg>
        </div>
        } } @if (!isDesktop && (item.asset | canDisplayAsset)) { @if ( item.asset.version_data | assetVersionUrl :
        item.asset.version_data.uuid : item.asset.version_data['status'] : item.asset.version_data.watermark_uuid :
        item.dimensions.width : true : item.asset.watermark_enabled | async; as imgSrc ) {
        <img [attr.data-picflow-hide]="true" [src]="imgSrc" alt="" />
        }
        <div class="video-indicator">
          <app-svg src="/assets/icons/play.svg"></app-svg>
        </div>
        } @if (!(item.asset | canDisplayAsset) && item.asset.version_data['status'] === 'failed') { @if (
        item.asset.version_data | assetVersionUrl : item.asset.version_data.uuid : item.asset.version_data['status'] :
        item.asset.version_data.watermark_uuid : item.dimensions.width : true : item.asset.watermark_enabled | async; as
        imgSrc ) {
        <img [attr.data-picflow-hide]="true" [src]="imgSrc" alt="" />
        } } }
      </a>
      }
    </div>
  </div>
  } @if (blockEmbedAssetView) {
  <div class="assets-section" [style.maxWidth]="embedMode ? '' : sectionWidth + 'px'">
    <div
      #assetGallery
      class="assets"
      [style.height]="sectionHeight + 'px'"
      [class.block-img-right-click]="!gallery.download_single_asset && accessLevel !== 'edit'"
    >
      @for (item of visibleItems; track item.asset.id) {
      <div
        class="asset"
        [class.with-bg]="
          item.asset.type !== 'image' || !(item.asset.version_data.asset_name | assetSupportsTransparency)
        "
        id="asset-{{ item.asset.id }}"
        [style.width]="item.dimensions.width + 'px'"
        [style.height]="item.dimensions.height + 'px'"
        [style.left]="item.dimensions.x + 'px'"
        [style.top]="item.dimensions.y + 'px'"
        (mouseenter)="hoverItem = item"
        (mouseleave)="hoverItem = undefined"
      >
        @if ( item.asset.type === 'image' && item.asset | assetUrl: item.asset.version_data.watermark_uuid :
        item.dimensions.width : true | async; as assetSrc ) {
        <img [src]="assetSrc" alt="" [attr.loading]="embedMode ? 'lazy' : 'eager'" />
        } @if (item.asset.type === 'video') { @if (item.asset | canDisplayAsset) {
        <app-video-viewer
          [videoData]="$any(item.asset.version_data.data)"
          [assetVersion]="item.asset.version_data"
          [asset]="item.asset"
          [uuid]="item.asset.version_data.uuid"
          [origin]="item.asset.version_data.asset_name"
          [poster]="
            item.asset.version_data
              | assetVersionUrl
                : item.asset.version_data.uuid
                : item.asset.version_data['status']
                : item.asset.version_data.watermark_uuid
                : item.dimensions.width
                : true
                : item.asset.watermark_enabled
              | async
          "
          [active]="hoverItem === item"
          [showUi]="false"
          [handleUi]="false"
          [autoplay]="hoverItem === item"
          [muted]="true"
          [allowUnmute]="true"
          [loop]="true"
          [targetWidth]="item.dimensions.width"
        ></app-video-viewer>
        } }
      </div>
      }
    </div>
  </div>
  } @if (!visibleItems) {
  <div class="fake-assets page">
    <div class="fake-asset"></div>
    <div class="fake-asset"></div>
    <div class="fake-asset"></div>
    <div class="fake-asset"></div>
    <div class="fake-asset"></div>
    <div class="fake-asset"></div>
    <div class="fake-asset"></div>
    <div class="fake-asset"></div>
    <div class="fake-asset"></div>
  </div>
  }
</div>
